export default __webpack_public_path__ + "static/904-ceed27767d5a80ef80b7c558562fe92e.gif";